import React, {useCallback, useEffect, useMemo, useState} from 'react';


// 뭔 파라미터가 이렇게 많니? 
// singleMode:Boolean  true:한번에 하나만 선택되는 경우 false:여러개 선택가능
const CheckOptions = ({id='', name='', lists=[], selected=[], title=null,
                        htmlLabel=false, singleMode=false, useCheckIcon=false, color="white", className='',
                        onChange = f=>f
    })=>{
    // 내부적으로 선택된 목록의 상태를 관리
    // 굳이?
    const [selectedList, setSelectedList] = useState([]);

    // 외부에서 주입되는 경우 선택된 값을 내부 항목에 적용
    useEffect(() => {
        setSelectedList(selected);
    }, [selected])
    
    //내부 항목이 변경될 경우 선택 여부를 확인하고 목록에 반영
    const onChangeSelected = useCallback((selected)=>{
        let tempSelectedList = null;
        if(singleMode){
            tempSelectedList = selected;
        }else{
            tempSelectedList = [...selectedList];
            const index = tempSelectedList.indexOf(selected);
            if (index < 0) {
                tempSelectedList.push(selected);
            } else {
                tempSelectedList.splice(index, 1);
            }
        }

        setSelectedList(tempSelectedList);
        onChange( {name:name, value:tempSelectedList} );
    }, [name, onChange, selectedList, singleMode]);

    // 항목의 선택(활성화)여부, 단일과 복수일때 배열 확인이 다르므로 함수로 사용
    const checkActive = useCallback((value)=>{
        if(singleMode){
            return selectedList===value;
        }else{
            return (selectedList.indexOf(value)!==-1);
        }   
    }, [selectedList, singleMode]);
    
    // 요소 목록
    const renderList = useMemo(()=>{
        let keys = null;
        const isArray = Array.isArray(lists);
        if( !isArray){
            keys = Object.keys(lists);
        }else{
            keys = lists;
        }

        return keys.map( (keyId, key)=>{
            let name = keyId;
            if( isArray){
                keyId = key;
            }else{
                name = lists[keyId];
            }
            if(name==='')return null;
            
            return(
                <button key={`${name}_${keyId}`} className={`btn ${checkActive(keyId)?'on':''}`}
                     onClick={() => onChangeSelected(keyId)} >
                    {name}
                </button>
            );
        });
    }, [checkActive, lists, onChangeSelected]);

    return (
        <div className={ className }>
            { renderList}
        </div>
    );
}//end

export default CheckOptions;
